import React, { useEffect, useState } from 'react';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { maxBounds, minBounds, Patterns, VALIDATIONS_TEXT } from "../../constants/Constants";
import Select, {
    components,
} from 'react-select';
import parse from 'html-react-parser';
import { ToastContainer, toast } from "react-toastify";
import { DatePicker } from 'rsuite';

const trainingList = [
    { value: 'training1', label: 'Management Training' },
    { value: 'training2', label: 'HR Training' },
    { value: 'training3', label: 'Management Training' }
]

const colourStyles = {
    control: styles => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            cursor: "pointer",
            backgroundColor: isDisabled ? 'red' : 'white',
            color: '#989898',
            textAlign: "left",
            ":hover": {
                backgroundColor: "#f4f4f4",
                color: "#126ADF"
            },
        }
    },
};


const EditEmployeesPopup = (props) => {
    const [disable, setDisable] = useState(false);
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm({
        mode: "onChange"
    });

    //On Close Button function
    const handleClose = () => props?.setEditPopup(false);

    //On Save Btn function

    //On Submit function
    const onSubmit = (data) => {

        setDisable(true);

        console.log("Edit Store Link", data);


        setTimeout(function () {
            setDisable(false);
            props?.setEditPopup(false)
            toast('Your Store Link Updated', {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }, 4000);
    }


    useEffect(() => {
        reset({
            Fname: 'Adamson',
            Lname: 'Byron',
            increment: '100',
            store: "Walleys",
            date: "03/02/2022",
            employeeEmail: "aaronmartin@gmail.com"
        })
    }, [])
    return (
        <>

            <Modal
                className='editModal'
                show={true}
                size="md"
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton className='border-0 p-0 mb-4'>
                    <Modal.Title className='heading-small '>Edit Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body className='border-0 p-0'>
                    <Form onSubmit={handleSubmit(onSubmit)} className="roundedForm">
                        <div className="innerFormScroll">
                            <Row>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Link URL"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}
                                            maxLength={maxBounds.NAME}
                                            {...register("Fname")}
                                        />
                                        {errors.name && <Form.Text>{errors.name.message}</Form.Text>}
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Link URL"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}
                                            maxLength={maxBounds.NAME}
                                            {...register("Lname")}
                                        />
                                        {errors.name && <Form.Text>{errors.name.message}</Form.Text>}
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="signUpName">
                                        <Form.Label>Start Date</Form.Label>
                                        <DatePicker defaultValue={new Date('2014-03-09')} className='form-control' format="dd/MM/yyyy" block oneTap placement="bottomStart" />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="signUpName">
                                        <Form.Label>Termination Date</Form.Label>
                                        <DatePicker defaultValue={new Date('2018-02-26')} className='form-control' format="dd/MM/yyyy" block oneTap placement="bottomStart" />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="signUpName">
                                        <Form.Label>Birth Date</Form.Label>
                                        <DatePicker defaultValue={new Date('2018-02-26')} className='form-control' format="dd/MM/yyyy" block oneTap placement="bottomStart" />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="signUpName">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="youremail@gmail.com"
                                            className={errors.forgotPasswordEmail ? "hasError" : ""}
                                            maxLength={maxBounds.EMAIL}
                                            {...register("employeeEmail", {
                                                required: {
                                                    value: true,
                                                    message: VALIDATIONS_TEXT.EMAIL_REQUIRED
                                                },
                                                pattern: {
                                                    value: Patterns.Email,
                                                    message: VALIDATIONS_TEXT.EMAIL_PATTERN
                                                },
                                                maxLength: {
                                                    value: maxBounds.EMAIL,
                                                    message: VALIDATIONS_TEXT.EMAIL_MAX
                                                }
                                            })}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="signUpName">
                                        <Form.Label>Training</Form.Label>
                                        <Select
                                            className="rumSelect normal w-100"
                                            classNamePrefix="rumSelect"
                                            options={trainingList}
                                            defaultValue={trainingList[2]}
                                            placeholder="All Stores"
                                            name="reactSelectName"
                                            // menuIsOpen={true}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={colourStyles}
                                            {...register("training")}
                                        />
                                    </Form.Group>
                                </Col>






                            </Row>
                        </div>
                        <div className="d-flex justify-content-end pt-3">
                            <Button type='submit' className="glowBtn"> {
                                !disable ? <>Save</> : <div className="load black"></div>
                            }</Button>
                        </div>
                        <ToastContainer />
                    </Form>


                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditEmployeesPopup